import type { Query } from '@ab-core/graphql/dist';
import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { getErrorLoggerFunction } from '../utils';
import { GET_COUPONS } from './gql/getCoupons';

type QueryDataType = Pick<Query, 'getCoupons'>;
type OutgoingDataType = QueryDataType['getCoupons'] | undefined;

const onError = getErrorLoggerFunction('getCoupons');

export const useGetCoupons = () => {
    const [outgoingData, setOutgoingData] = useState<OutgoingDataType>(undefined);

    const { data, loading, refetch, error } = useQuery<QueryDataType>(GET_COUPONS, {
        onError
    });

    useEffect(() => {
        if (data) {
            setOutgoingData(data.getCoupons);
        }
    }, [data]);

    return {
        coupons: outgoingData,
        error: !!error,
        success: !!data,
        loading,
        refetch
    };
};
